module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idFrame",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "flex"
    },
    attrs: {
      "id": "idFrame"
    }
  }, [_c('div', {
    staticClass: "TopbarItem",
    staticStyle: {
      "flex": "0 0 auto",
      "width": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "TopbarItem",
    staticStyle: {
      "flex": "1 0 auto",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.custName))]), _vm._v(" "), _c('div', {
    staticClass: "TopbarItem",
    staticStyle: {
      "flex": "3 0 auto"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "TopbarItem",
    staticStyle: {
      "flex": "0 0 auto",
      "padding-left": "6px",
      "padding-right": "6px",
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.userAcct))]), _vm._v(" "), _c('div', {
    staticClass: "TopbarItem",
    staticStyle: {
      "flex": "0 0 auto",
      "padding-left": "6px",
      "padding-right": "6px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onExit
    }
  }, [_vm._v(_vm._s(_vm.getLangText("退出")))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27d3b4c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/topbar.vue
// module id = 761
// module chunks = 1